import { render, staticRenderFns } from "./SiteNavItem.vue?vue&type=template&id=01bfdaae&scoped=true&"
import script from "./SiteNavItem.vue?vue&type=script&lang=js&"
export * from "./SiteNavItem.vue?vue&type=script&lang=js&"
import style0 from "./SiteNavItem.vue?vue&type=style&index=0&id=01bfdaae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01bfdaae",
  null
  
)

export default component.exports